import iphoneBefore from "@/assets/iphone-before-new.jpg";
import iphoneAfter from "@/assets/skins/mockup-autumn-floral.jpg";
import cameraBefore from "@/assets/camera-before.jpg";
import cameraAfter from "@/assets/camera-after.jpg";
import macbookBefore from "@/assets/macbook-before.jpg";
import macbookAfter from "@/assets/macbook-after.jpg";
import ps5ConsoleBefore from "@/assets/models/ps5-console-before.webp";
import ps5ConsoleAfter from "@/assets/skins/ps5-forged-carbon-after.webp";

export interface HeroSlideItem {
  id: string;
  enabled: boolean;
  /** Translation keys used when the matching text override is empty */
  labelKey?: string;
  title1Key?: string;
  title2Key?: string;
  descriptionKey?: string;
  /** Plain-text overrides managed from the admin panel */
  label?: string;
  title1?: string;
  title2?: string;
  description?: string;
  beforeImage: string;
  afterImage: string;
  icon: string;
  ctaPath: string;
  comingSoon?: boolean;
}

export const HERO_SLIDE_ICONS = [
  "Smartphone",
  "Laptop",
  "Tablet",
  "Gamepad2",
  "Camera",
  "Headphones",
  "Watch",
  "Sparkles",
] as const;

export const DEFAULT_HERO_SLIDES: HeroSlideItem[] = [
  {
    id: "phones",
    enabled: true,
    labelKey: "telephones",
    title1Key: "heroTelephoneTitle1",
    title2Key: "heroTelephoneTitle2",
    descriptionKey: "heroTelephoneDesc",
    beforeImage: iphoneBefore,
    afterImage: iphoneAfter,
    icon: "Smartphone",
    ctaPath: "/category/phones",
  },
  {
    id: "macbooks",
    enabled: true,
    labelKey: "computers",
    title1Key: "heroComputerTitle1",
    title2Key: "heroComputerTitle2",
    descriptionKey: "heroComputerDesc",
    beforeImage: macbookBefore,
    afterImage: macbookAfter,
    icon: "Laptop",
    ctaPath: "/category/macbooks",
  },
  {
    id: "consoles",
    enabled: true,
    labelKey: "consoles",
    title1Key: "heroConsoleTitle1",
    title2Key: "heroConsoleTitle2",
    descriptionKey: "heroConsoleDesc",
    beforeImage: ps5ConsoleBefore,
    afterImage: ps5ConsoleAfter,
    icon: "Gamepad2",
    ctaPath: "/category/consoles",
  },
  {
    id: "cameras",
    enabled: true,
    labelKey: "cameraPhoto",
    title1Key: "heroCameraPhotoTitle1",
    title2Key: "heroCameraPhotoTitle2",
    descriptionKey: "heroCameraPhotoDesc",
    beforeImage: cameraBefore,
    afterImage: cameraAfter,
    icon: "Camera",
    ctaPath: "/category/cameras",
  },
];
